



import Vue from "vue";
export default Vue.extend({
  props: ["text"],
  setup(props) {
    return {};
  },
});
